import createReducer from 'app/redux/utils/create-reducer';

import { initState, ReducerHandlers } from './workers';

export default createReducer(initState, ReducerHandlers);



// WEBPACK FOOTER //
// ./src/redux/blog/get-all/reducer.js